"use client";
import React, { useState } from "react";

const InsightsLeft = () => {
  const [yearFilterBtnSelection, setYearFilterBtnSelection] = useState("6 M");

  const handleYearFilterClick = (year) => {
    setYearFilterBtnSelection(year);
  };
  return (
    <div className="border border-solid border-[#E0E0E0] p-4 gap-4 w-[393px] h-[434px] rounded-lg">
      <p className="font-semibold text-base text-[#333333]">
        Stock Price of Simulation
      </p>
      <img src="/images/monteSimulation.png" alt="" className="" />
      <p className="font-medium text-[8px] text-[#DBA12C]">
        Note: This graph is derived from Monte Carlo simulation
      </p>
      <div className="flex justify-center items-center">
        <div className="flex justify-between items-center mt-4 mb-2 rounded-full w-[40%] bg-[#F1F1F6]">
          <button
            onClick={() => handleYearFilterClick("6 M")}
            className={`text-xs font-bold px-2 py-1 text-[#848484] ${
              yearFilterBtnSelection === "6 M"
                ? "bg-[#A0FF77] !text-[#262626] rounded-full m-0.5 py-1"
                : ""
            }`}
          >
            6 M
          </button>
          <button
            className={`text-xs font-bold px-2 py-1 text-[#848484] ${
              yearFilterBtnSelection === "1 Y"
                ? "bg-[#A0FF77] !text-[#262626] rounded-full m-0.5 py-1"
                : ""
            }`}
            onClick={() => handleYearFilterClick("1 Y")}
          >
            1 Y
          </button>
          <button
            className={`text-xs font-bold px-2 py-1 text-[#848484] ${
              yearFilterBtnSelection === "3 Y"
                ? "bg-[#A0FF77] !text-[#262626] rounded-full m-0.5 py-1"
                : ""
            }`}
            onClick={() => handleYearFilterClick("3 Y")}
          >
            3 Y
          </button>
        </div>
      </div>
      {yearFilterBtnSelection === "6 M" ? (
        <>
          <div className="flex justify-between">
            <div>
              <p className="text-xs font-semibold text-[#8B8B8B]">
                Expected Return
              </p>
              <p className="text-xs font-bold text-[#333333]">10%</p>
            </div>
            <div>
              <p className="text-xs font-semibold text-[#8B8B8B]">
                Probability
              </p>
              <p className="text-xs font-bold text-[#333333]">43.89</p>
            </div>
          </div>
          <div className="flex justify-between mt-4">
            <div>
              <p className="text-xs font-semibold text-[#8B8B8B]">
                Expected Return
              </p>
              <p className="text-xs font-bold text-[#333333]">25%</p>
            </div>
            <div>
              <p className="text-xs font-semibold text-[#8B8B8B]">
                Probability
              </p>
              <p className="text-xs font-bold text-[#333333]">23.79</p>
            </div>
          </div>{" "}
          <div className="flex justify-between mt-4">
            <div>
              <p className="text-xs font-semibold text-[#8B8B8B]">
                Expected Return
              </p>
              <p className="text-xs font-bold text-[#333333]">50%</p>
            </div>
            <div>
              <p className="text-xs font-semibold text-[#8B8B8B]">
                Probability
              </p>
              <p className="text-xs font-bold text-[#333333]">5.89</p>
            </div>
          </div>
        </>
      ) : yearFilterBtnSelection === "1 Y" ? (
        <>
          <div className="flex justify-between">
            <div>
              <p className="text-xs font-semibold text-[#8B8B8B]">
                Expected Return
              </p>
              <p className="text-xs font-bold text-[#333333]">14%</p>
            </div>
            <div>
              <p className="text-xs font-semibold text-[#8B8B8B]">
                Probability
              </p>
              <p className="text-xs font-bold text-[#333333]">43.89</p>
            </div>
          </div>
          <div className="flex justify-between mt-4">
            <div>
              <p className="text-xs font-semibold text-[#8B8B8B]">
                Expected Return
              </p>
              <p className="text-xs font-bold text-[#333333]">25%</p>
            </div>
            <div>
              <p className="text-xs font-semibold text-[#8B8B8B]">
                Probability
              </p>
              <p className="text-xs font-bold text-[#333333]">23.79</p>
            </div>
          </div>{" "}
          <div className="flex justify-between mt-4">
            <div>
              <p className="text-xs font-semibold text-[#8B8B8B]">
                Expected Return
              </p>
              <p className="text-xs font-bold text-[#333333]">50%</p>
            </div>
            <div>
              <p className="text-xs font-semibold text-[#8B8B8B]">
                Probability
              </p>
              <p className="text-xs font-bold text-[#333333]">5.89</p>
            </div>
          </div>
        </>
      ) : yearFilterBtnSelection === "3 Y" ? (
        <>
          <div className="flex justify-between">
            <div>
              <p className="text-xs font-semibold text-[#8B8B8B]">
                Expected Return
              </p>
              <p className="text-xs font-bold text-[#333333]">10%</p>
            </div>
            <div>
              <p className="text-xs font-semibold text-[#8B8B8B]">
                Probability
              </p>
              <p className="text-xs font-bold text-[#333333]">43.89</p>
            </div>
          </div>
          <div className="flex justify-between mt-4">
            <div>
              <p className="text-xs font-semibold text-[#8B8B8B]">
                Expected Return
              </p>
              <p className="text-xs font-bold text-[#333333]">25%</p>
            </div>
            <div>
              <p className="text-xs font-semibold text-[#8B8B8B]">
                Probability
              </p>
              <p className="text-xs font-bold text-[#333333]">23.79</p>
            </div>
          </div>{" "}
          <div className="flex justify-between mt-4">
            <div>
              <p className="text-xs font-semibold text-[#8B8B8B]">
                Expected Return
              </p>
              <p className="text-xs font-bold text-[#333333]">50%</p>
            </div>
            <div>
              <p className="text-xs font-semibold text-[#8B8B8B]">
                Probability
              </p>
              <p className="text-xs font-bold text-[#333333]">5.89</p>
            </div>
          </div>
        </>
      ) : null}
    </div>
  );
};

export default InsightsLeft;
